import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from 'components/drawers/utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from 'components/drawers/utility-drawer/utility-drawer.component';
import APIDefinitions from 'components/api-definitions/api-definitions.component';
import { EMAIL_PULSE_DEFINITIONS } from '../email-pulse-definitions/email-pulse-definitions';
import type { TFunction } from 'i18next';

type ApiDetailsDrawerProps = {
  isOpen: boolean;
  close: () => void;
};

/**
 * Adapts EmailPulseMetricDefinition to APIDefinitions component format.
 * Maps getLabel -> getTitle to match the expected interface.
 */
const adaptDefinition = (
  definition: (typeof EMAIL_PULSE_DEFINITIONS)[string],
) => ({
  getTitle: (t: TFunction) => definition.getLabel(t),
  getDescription: (t: TFunction) => definition.getDescription(t),
});

const deliverabilityDefinitions = [
  EMAIL_PULSE_DEFINITIONS.emailsSent,
  EMAIL_PULSE_DEFINITIONS.emailsDelivered,
  EMAIL_PULSE_DEFINITIONS.deliveryRate,
  EMAIL_PULSE_DEFINITIONS.emailsDeferred,
  EMAIL_PULSE_DEFINITIONS.emailsBounced,
  EMAIL_PULSE_DEFINITIONS.hardBounces,
  EMAIL_PULSE_DEFINITIONS.softBounces,
  EMAIL_PULSE_DEFINITIONS.bounceRate,
  EMAIL_PULSE_DEFINITIONS.emailsDropped,
].map(adaptDefinition);

const recipientActionsDefinitions = [
  EMAIL_PULSE_DEFINITIONS.emailsOpened,
  EMAIL_PULSE_DEFINITIONS.openRate,
  EMAIL_PULSE_DEFINITIONS.uniqueOpens,
  EMAIL_PULSE_DEFINITIONS.clicks,
  EMAIL_PULSE_DEFINITIONS.uniqueClicks,
  EMAIL_PULSE_DEFINITIONS.clickRate,
  EMAIL_PULSE_DEFINITIONS.clickThroughRate,
  EMAIL_PULSE_DEFINITIONS.unsubscribes,
  EMAIL_PULSE_DEFINITIONS.unsubscribeRate,
  EMAIL_PULSE_DEFINITIONS.spamReports,
  EMAIL_PULSE_DEFINITIONS.spamReportRate,
].map(adaptDefinition);

const ApiDetailsDrawer = ({ isOpen, close }: ApiDetailsDrawerProps) => {
  const { t } = useTranslation();

  return (
    <UtilityDrawer
      open={isOpen}
      onClose={close}
      title={t('page.emailPulse.apiDefinitionsDrawer.reportFields.label')}
    >
      <UtilityDrawerBody>
        <Stack spacing={2}>
          <APIDefinitions
            type={t(
              'page.emailPulse.apiDefinitionsDrawer.deliverability.label',
            )}
            definitions={deliverabilityDefinitions}
          />
          <APIDefinitions
            type={t(
              'page.emailPulse.apiDefinitionsDrawer.recipientActions.label',
            )}
            definitions={recipientActionsDefinitions}
          />
        </Stack>
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default ApiDetailsDrawer;
